import {
  DocumentAnalysis,
  DocumentAnalysisLineItemInput,
  PaymentFrequency,
  TaxType,
} from '@admiin-com/ds-graphql';
import { Bill } from '../PayBillCreateForm';
import { convertCentsToAmount, DATE_FORMATS } from '@admiin-com/ds-common';
import { DateTime } from 'luxon';

export const transformDocumentAnalysisToBill = (
  documentAnalysis: DocumentAnalysis,
  defaultFrom: any
): Bill => {
  const from =
    documentAnalysis.matchedContact ??
    documentAnalysis.matchedEntity ??
    documentAnalysis.newContact ??
    undefined;
  return {
    checked: true,
    document: documentAnalysis.documents?.[0] ?? null,
    documentAnalysis: documentAnalysis,
    from: from ?? defaultFrom,
    to: null,
    amount: convertCentsToAmount(documentAnalysis.task?.amount ?? 0),
    dueAt:
      documentAnalysis.task?.dueAt ??
      DateTime.now().toFormat(DATE_FORMATS.BACKEND_DATE),
    issuedAt: documentAnalysis.task?.issuedAt ?? '',
    lineItems: (
      documentAnalysis.task?.lineItems?.filter((item) => item !== null) ?? []
    ).map((item) => ({
      ...item,
      taxType:
        (from as any)?.metadata?.subCategory === 'TAX'
          ? TaxType.NO_GST
          : item?.taxType ?? TaxType.NO_GST,
      unitPrice: convertCentsToAmount(item?.unitPrice ?? 0),
      price: convertCentsToAmount(item?.price ?? 0),
    })) as DocumentAnalysisLineItemInput[],
    reference: documentAnalysis.task?.reference ?? '',
    bpay: documentAnalysis.matchedContact?.bpay ?? documentAnalysis.bpay,
    bank:
      (documentAnalysis.matchedContact?.bank
        ? {
            ...documentAnalysis.matchedContact.bank,
            __typename: 'DocumentAnalysisBankAccount',
          }
        : null) ??
      documentAnalysis.bank ??
      null,
    paymentFrequency: PaymentFrequency.ONCE,
    taxSettlementStatus: documentAnalysis.task?.settlementStatus ?? undefined,
    taxDocumentType: documentAnalysis.task?.documentType ?? undefined,
    period: documentAnalysis.task?.period ?? undefined,
    year: documentAnalysis.task?.year ?? undefined,
  };
};
